import React, { useState } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import Loader from '@node-space/storybook-components/dist/Loader'
import PageHeader from '@node-space/storybook-components/dist/PageHeader'
import { Box, Button, Icon, Text } from '@node-space/ui-components'
import { useNotificationDestinationsQuery } from 'hooks/queries/WebHooks/useNotificationDestinationsQuery'
import { ActionIds } from 'types/types'
import { DestinationsList } from './DestinationsList'
import { EmptyState } from './EmptyState'
import { IntegrationsSheet } from './Sheet/IntegrationsSheet'

export const Destinations = () => {
  const { t } = useTranslation()
  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const [action, setAction] = useAtom(actionAtom)

  const onAddNewWebHook = () => {
    setAction({
      ...action,
      actionId: ActionIds?.HOOKS,
      header: t('integrations.addNewWebhook'),
      onClose: () => {
        setIsSheetOpen(false)
      },
    })
    setIsSheetOpen(true)
  }

  const { data: { content: destinationList } = {}, isPending } = useNotificationDestinationsQuery(
    '',
    50
  )

  if (isPending) {
    return (
      <Box flex justify="center" paddingT={24} data-testid="loader">
        <Loader theme="dark" size="large" data-testid="loader" />
      </Box>
    )
  }
  const hasDestinations = destinationList?.length > 0

  return (
    <>
      {hasDestinations ? (
        <Box paddingT={24}>
          <PageHeader
            description={
              <Text variant="body-text" color="subdued">
                {t('integrations.hooksDescription')}
              </Text>
            }
            renderRightSection={
              <Button
                onClick={onAddNewWebHook}
                name={t('integrations.addHook')}
                iconElement={<Icon name="Plus" />}
              >
                {t('integrations.addHook')}
              </Button>
            }
          />
          <Box flex className="md:flex-row flex-col" gapX={24} width="full">
            <Box className="justify-center items-center w-full border border-gray-04 bg-white p-4">
              <DestinationsList destinations={destinationList} />
            </Box>
          </Box>
        </Box>
      ) : (
        <EmptyState onAddNewWebHook={onAddNewWebHook} />
      )}

      <IntegrationsSheet isSheetOpen={isSheetOpen} />
    </>
  )
}
